import Reveal from "@/components/Reveal";
import { Building2 } from "lucide-react";

const LOGOS = [
  { name: "Allianz", file: "allianz" },
  { name: "Aon", file: "aon" },
  { name: "AXA", file: "axa" },
  { name: "Blue Assistance", file: "blue-assistance" },
  { name: "FASDAC", file: "fasdac" },
  { name: "FASI", file: "fasi" },
  { name: "Generali", file: "generali" },
  { name: "Howden", file: "howden" },
  { name: "Insalute", file: "insalute" },
  { name: "My Assistance", file: "my-assistance" },
  { name: "ONHC", file: "onhc" },
  { name: "Pellegrini", file: "pellegrini" },
  { name: "Poste Vita", file: "postevita" },
  { name: "Previmedical", file: "previmedical" },
  { name: "Salute Semplice", file: "salute-semplice" },
  { name: "Unisalute", file: "unisalute" },
];

export default function Insurances() {
  return (
    <section id="assicurazioni" data-testid="insurances-section" className="py-16 lg:py-20 bg-cream border-b border-pine/10">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="bg-paper border-l-[3px] border-terracotta rounded-md p-8 lg:p-10">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-terracotta mb-3">Sapevi che?</p>
            <h2 className="font-serif italic tracking-tight text-pine text-2xl sm:text-3xl lg:text-4xl leading-snug max-w-2xl">
              Presso il poliambulatorio si accettano tutte le principali assicurazioni sanitarie.
            </h2>
            <p className="mt-4 text-sm lg:text-base text-moss leading-relaxed max-w-2xl">
              Le convenzioni con fondi e assicurazioni valgono{" "}
              <span className="font-semibold text-pine">esclusivamente per le sedute in studio</span>{" "}
              presso Fisioterapia Italia Torino, Via Marenco 28/B — non per i trattamenti a domicilio.
            </p>
            <div data-testid="insurances-grid" className="mt-8 grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-8 gap-3">
              {LOGOS.map((l) => (
                <div
                  key={l.name}
                  data-testid={`insurance-logo-${l.file}`}
                  title={l.name}
                  className="flex items-center justify-center bg-bone border border-pine/10 rounded-md px-3 py-3 h-14 hover:border-terracotta/50 transition-colors duration-300"
                >
                  <img
                    src={`/loghi/${l.file}.webp`}
                    alt={`Logo ${l.name}`}
                    loading="lazy"
                    className="max-h-8 max-w-full object-contain"
                  />
                </div>
              ))}
            </div>
            <a
              data-testid="insurances-map-link"
              href="https://www.google.com/maps/search/?api=1&query=Via+Marenco+28%2FB+Torino"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 mt-6 text-xs font-bold uppercase tracking-[0.16em] text-terracotta hover:text-pine transition-colors duration-300"
            >
              <Building2 size={14} strokeWidth={1.5} /> Vedi il poliambulatorio sulla mappa
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
